var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M409.6,153.6h-384C11.46,153.6,0,165.06,0,179.2v230.4c0,14.14,11.46,25.6,25.6,25.6h153.6v51.2h-59.733V512h196.267 v-25.6H256v-51.2h153.6c14.14,0,25.6-11.46,25.6-25.6V179.2C435.2,165.06,423.74,153.6,409.6,153.6z M230.4,486.4h-25.6v-51.2 h25.6V486.4z M409.6,409.6h-384V179.2h384V409.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 332.8,
    y: 51.2,
    width: 128,
    height: 25.6
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 332.8,
    y: 102.4,
    width: 128,
    height: 25.6
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M486.4,0H307.2c-14.14,0-25.6,11.46-25.6,25.6V128h25.6V25.6h179.2v460.8H341.333V512H486.4c14.14,0,25.6-11.46,25.6-25.6 V25.6C512,11.46,500.54,0,486.4,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8d6c49c07ee41fa35943b160f372335b.svg";
export { ForwardRef as ReactComponent };